import { createResourceApi } from 'resources/ResourceApi';
import { RequestContactApiItem } from 'typings/api';

export default createResourceApi<RequestContactApiItem>('request_contacts');
